{
  "comment": "M7 spec §10.2 (S10, src/story/clock.ts): storyMult derived from career.story and sent as-is with setStoryClock; the worker applies min(storyExtractionMult × storyMult, storyMultCap) to AI extraction only. Before the finale: storyMult = max(tier row, idleRamp) + alertStep × alerts, where tiers 0–2 use baseMult and the idleRamp rises while the tier is 0–2 (after startOnlineDay online days, +step for each started block of everyOnlineDays online days, capped at idleRamp.cap) and freezes at the tier-3 crossing. tierRows: the tier's mult and its one-off stability drop (once per career at the crossing, never below dropFloor, never closing) with its Wire cause. After the commit the finale row of the newest path in force replaces the tier row, the idleRamp and the alerts (exposePending: a vote not resolved yet); Expose and Guardians both in force take the lower row; a Blackmail exit adds blackmailSurcharge.add for blackmailSurcharge.onlineDays online days. cap mirrors gate.json storyMultCap (the worker caps). The ladder must ramp: baseMult < tier 3 < tier 4 < tier 5 ≤ cap (clock.test.ts). Placeholders for the balance pass (M7 spec §15 item 4); tune freely.",
  "baseMult": 1,
  "tierRows": [
    {
      "tier": 3,
      "mult": 1.3,
      "drop": 5,
      "cause": "Tethys adds fracture shifts at the Carrow vein"
    },
    {
      "tier": 4,
      "mult": 1.8,
      "drop": 8,
      "cause": "Tethys opens two new fracture sites"
    },
    {
      "tier": 5,
      "mult": 2.4,
      "drop": 15,
      "cause": "Tethys runs every rig around the clock: strip it before they can stop us"
    }
  ],
  "alertStep": 0.15,
  "idleRamp": {
    "startOnlineDay": 60,
    "everyOnlineDays": 10,
    "step": 0.2,
    "cap": 2
  },
  "finaleRows": {
    "exposePassed": 0.5,
    "exposeFailed": 2,
    "blackmail": 2.5,
    "guardiansFloor": 1.3,
    "guardians": 1.8,
    "sell": 1.6,
    "exposePending": 2
  },
  "blackmailSurcharge": {
    "add": 0.5,
    "onlineDays": 30
  },
  "cap": 2.6,
  "dropFloor": 30,
  "idleRampWire": {
    "headline": "Tethys adds fracture shifts",
    "source": "mutualBulletin",
    "severity": 1
  }
}
